import jQuery from 'jquery';
import { useLocation, Link } from 'react-router-dom';


function coll() {
    jQuery('#sub-list').toggle(400)    
}

function clickHome() {
    /*var element = document.getElementById("offcanvasExample")
    jQuery("#offcanvasExample").css("visibility", "hidden");
    jQuery("#offcanvasExample").removeAttr("role");
    jQuery("#offcanvasExample").removeAttr("aria-modal");
    jQuery("#offcanvasExample").attr("aria-hidden", "true");
    element.classList.remove("show")
    jQuery(".offcanvas-backdrop").remove()
    element.style.display = "-100%"
    */
   document.getElementById("offcanbtn").click();
}

const Header = () => {

    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");


    return (
        <div>
            <div id="header" className="section header-section">

                <div className="container">

                    <div className="header-wrap">

                        <div className="header-logo">
                            <Link to="/"><img src="assets/images/logo.jpg" alt="" /></Link>
                        </div>

                        <div className="header-menu d-none d-lg-block"  style={{ textAlign: 'left' }}>
                            <ul className="main-menu">
                                <li className={splitLocation[1] === "" ? "active-menu" : ""}>
                                    <Link to="/">Home</Link>
                                </li>
                                <li className={splitLocation[1] === "about" ? "active-menu" : ""}>
                                    <Link to="/about">Aboute Us</Link>
                                </li>
                                <li><Link to="#">Products <span className='menu-icon'></span></Link>
                                    <ul class="sub-menu">
                                        <li><Link to="https://onebiss.themichaelstech.com">OneBiss</Link></li>
                                        <li><Link to="#">Peddle</Link></li>
                                    </ul>
                                </li>
                                <li className={splitLocation[1] === "service" ? "active-menu" : ""}><Link to="/service">Services</Link>
                                </li>
                                <li className={splitLocation[1] === "blog" ? "active-menu" : ""}><Link to="/blog">Blog</Link>
                                </li>
                                <li className={splitLocation[1] === "contact" ? "active-menu" : ""}><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>

                        <div className="header-meta">

                            <div className="header-btn d-none d-xl-block">
                                <Link className="btn" to="tel:+2349038224320">Have any Question?</Link>
                            </div>
                            <div className="header-toggle d-lg-none">
                                <button data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" id='offcanbtn'>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div className="offcanvas offcanvas-start" id="offcanvasExample">
                <div className="offcanvas-header">
                    <div className="offcanvas-logo">
                        <Link to="/"><img src="assets/images/logo-white.png" alt="" /></Link>
                    </div>
                    <button type="button" className="close-btn" data-bs-dismiss="offcanvas"><i className="flaticon-close"></i></button>
                </div>

                <div className="offcanvas-body" style={{ textAlign: 'left' }}>
                    <div className="offcanvas-menu">
                        <ul className="main-menu">
                            <li className={splitLocation[1] === "" ? "active-menu" : ""}>
                                <Link onClick={clickHome} to="/">Home</Link>
                            </li>
                            <li className={splitLocation[1] === "about" ? "active-menu" : ""}>
                                <Link onClick={clickHome} to="/about">Aboute Us</Link>
                            </li>
                            <li id='sub-menu-coll' onClick={coll}><Link to="#">Products</Link>
                                
                                <ul class="sub-menu" id='sub-list' style={{boxSizing: 'border-box', display: 'none'}}>
                                    <li><Link onClick={clickHome} to="https://onebiss.themichaelstech.com">OneBiss</Link></li>
                                    <li><Link onClick={clickHome} to="#">Peddle</Link></li>
                                </ul>
                            </li>
                            <li className={splitLocation[1] === "service" ? "active-menu" : ""}><Link onClick={clickHome} to="/service">Services</Link>
                            </li>
                            <li className={splitLocation[1] === "blog" ? "active-menu" : ""}><Link onClick={clickHome} to="/blog">Blog</Link>
                            </li>
                            <li className={splitLocation[1] === "contact" ? "active-menu" : ""}><Link onClick={clickHome} to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;